import React from 'react'
import asu from 'app/assets/ASU.png'
import helios from 'app/assets/Helios.png'
import maricopa from 'app/assets/MCCD.png'
import './asulogo.css'

export default () => (
  [
    <img key={1} className='' alt="" src={helios} />,
    <img key={2} className='asu' alt="" src={asu} />,
    <img key={3} className='maricopa_cc' alt="" src={maricopa} />,
  ]
)